
<template lang="pug">
i.wi(:class="icon")
</template>

<script>
import 'weathericons/sass/weather-icons.scss'

export default {
  props: {
    night: Boolean,
    text: String,
  },

  computed: {
    icon() {
      const icon = []

      const cloudy  = this.text.indexOf('曇') !== -1
      const rainy   = this.text.indexOf('雨') !== -1
      const thunder = this.text.indexOf('雷') !== -1
      if(rainy) {
        if(thunder) {
          icon.push(this.night ? 'wi-night-alt-thunderstorm' : 'wi-day-thunderstorm')
        }
        else {
          icon.push(this.night ? 'wi-night-alt-rain' : 'wi-day-rain')
        }
      }
      else if(cloudy && !thunder) {
        icon.push(this.night ? 'wi-night-alt-cloudy' : 'wi-day-cloudy')
      }
      else if(thunder) {
        icon.push(this.night ? 'wi-night-alt-lightning' : 'wi-day-lightning')
      }
      else {
        icon.push(this.night ? 'wi-night-clear' : 'wi-day-sunny')
      }

      return icon
    },
  },
}
</script>
